import { CaseWorker } from "../common";
import { CalculationStatus, CalculationType, LocationCalculationType, RiskAssessmentStatus } from "../enums";

export class RiskCalculationItem {

    public caseWorker: CaseWorker | undefined;

    public id: string | undefined;
    public number: string | undefined;
    public name: string | undefined;
    public region: number | undefined;

    public calculationType: CalculationType | undefined;

    public compoundName: string | undefined;
    public concentration: string | undefined;

    public status: CalculationStatus | undefined;

    public calculationDate: Date | undefined;

    public excessFactor: number | undefined;

    public riskAssessment: RiskAssessmentStatus | undefined;

    public calculationModelType: number | undefined;

    public calculationFailed: boolean | undefined;

    public calculationFailedErrorMessage: string | undefined;

    public constructor(init: Partial<RiskCalculationItem>) {
        Object.assign(this, init);
    }
}